const events = [];

const log = (...args) => {
  events.push([Date.now(), ...args]);
  console.log(...events[events.length - 1]);
}

export default log;
